var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSecondaryDarkMode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 800,
    height: 160,
    viewBox: "0 0 800 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.9811 80C28.9811 51.9245 51.9245 28.9811 80 28.9811C108.075 28.9811 131.019 51.9245 131.019 80C131.019 108.075 108.075 131.019 80 131.019C51.9245 131.019 28.9811 108.075 28.9811 80ZM80 0C35.9245 0 0 35.9245 0 80C0 124.075 35.9245 160 80 160C124.075 160 160 124.075 160 80C160 35.9245 124.075 0 80 0Z",
    fill: "url(#paint0_linear)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M620.981 50.7168L646.641 107.17H638.792L632.453 93.2828H609.509L603.17 107.17H595.321L620.981 50.7168ZM620.679 67.6225L611.924 86.9432H629.434L620.679 67.6225ZM203.472 60.0756C198.34 65.5095 195.623 71.8492 195.623 80.0001C195.623 88.1511 198.038 94.7926 203.17 99.9246C208.302 105.057 214.943 107.774 222.792 107.774C230.641 107.774 237.283 105.057 242.415 99.9246C247.547 94.4907 250.264 87.8492 250.264 80.0001C250.264 71.8492 247.547 65.2077 242.415 60.0756C237.283 54.9435 230.641 52.2265 222.49 52.2265C214.943 52.2265 208.906 54.9435 203.472 60.0756ZM211.924 67.9246C214.641 64.6039 218.264 63.0944 222.792 63.0944C227.623 63.0944 231.245 64.9058 233.66 67.9246C236.377 70.9435 237.887 74.868 237.887 80.0001C237.887 85.1322 236.377 89.3586 233.66 92.3775C230.943 95.6982 227.321 97.2077 222.792 97.2077C218.264 97.2077 214.641 95.3963 211.924 92.3775C209.207 89.0567 207.698 85.1322 207.698 80.302C207.698 75.1699 209.207 71.2454 211.924 67.9246ZM290.717 52.8301H272.302V107.17H283.773V86.0377L290.415 85.7358C292.528 85.7358 295.245 85.132 298.264 83.6226C301.585 82.1131 303.698 79.9999 305.207 77.283C306.717 74.566 307.321 71.5471 307.321 68.5282C307.321 63.698 305.811 60.0754 302.792 57.0565C299.774 54.3396 295.849 52.8301 290.717 52.8301ZM283.773 76.3773V62.4905L286.49 62.1886C289.207 62.1886 291.623 62.7924 293.132 63.9999C294.641 65.2075 295.547 67.0188 295.547 69.132C295.547 71.2452 294.943 72.7547 293.434 74.2641C291.924 75.7735 290.113 76.3773 288.302 76.3773H283.773ZM327.849 52.8301H358.339V63.698H339.622V74.566H358.339V85.132H339.622V96.3018H358.339V107.17H327.849V52.8301ZM429.283 52.8301H417.811H417.509V87.849L392.755 52.8301H381.283V107.17H393.056V72.1509L417.811 107.17H429.283V52.8301ZM482.717 52.8301H490.264V73.6603H516.226V52.8301H523.472V107.17H516.226V81.2075H490.264V107.17H482.717V52.8301ZM578.113 52.8301H547.924V107.17H578.113V99.9245H555.472V81.2075H578.113V73.9622H555.472V60.3773H578.113V52.8301ZM673.208 52.8301H665.962V107.17H691.019V99.9245H673.208V52.8301ZM701.887 52.8301H735.094V60.3773H722.113V107.17H714.868V60.3773H701.887V52.8301ZM762.264 52.8301H754.717V107.17H762.264V81.2075H788.226V107.17H795.472V52.8301H788.226V73.6603H762.264V52.8301Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 0.0325266,
    y1: 159.983,
    x2: 160,
    y2: 159.983,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EC008C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#AE108E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#771E90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#4F2891"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#372F92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3A5696"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecondaryDarkMode);
export default __webpack_public_path__ + "static/media/secondary-dark-mode.b09edca386c3d57893d5372041f7614a.svg";
export { ForwardRef as ReactComponent };